import { render } from "./AposGridManager.vue?vue&type=template&id=d01c479c&scoped=true"
import script from "./AposGridManager.vue?vue&type=script&lang=js"
export * from "./AposGridManager.vue?vue&type=script&lang=js"

import "./AposGridManager.vue?vue&type=style&index=0&id=d01c479c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01c479c"],['__file',"layout-widget/ui/apos/components/AposGridManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d01c479c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d01c479c', __exports__)) {
    api.reload('d01c479c', __exports__)
  }
  
  module.hot.accept("./AposGridManager.vue?vue&type=template&id=d01c479c&scoped=true", () => {
    api.rerender('d01c479c', render)
  })

}


export default __exports__